// Geometric placeholder used where a photo would go in the final design.
// Variant + hue control the look; nothing photo-like so it never reads
// as a screenshot or a real avatar.

// "plain" is the colour alone, for a strip too small to carry a pattern.
type Variant = "dots" | "lines" | "grid" | "rings" | "block" | "plain";

interface AbstractTileProps {
  variant?: Variant;
  hue?: number;
  label?: string;
  className?: string;
}

export function AbstractTile({ variant = "dots", hue = 30, label, className = "" }: AbstractTileProps) {
  const background = `hsl(${hue} 22% 88%)`;

  let pattern = "";
  if (variant === "dots") {
    pattern = `radial-gradient(circle, hsl(${hue} 35% 30% / 0.55) 1.5px, transparent 2px)`;
  } else if (variant === "lines") {
    pattern = `repeating-linear-gradient(45deg, hsl(${hue} 35% 30% / 0.5) 0 1px, transparent 1px 8px)`;
  } else if (variant === "grid") {
    pattern = `linear-gradient(hsl(${hue} 35% 30% / 0.35) 1px, transparent 1px), linear-gradient(90deg, hsl(${hue} 35% 30% / 0.35) 1px, transparent 1px)`;
  } else if (variant === "rings") {
    pattern = `repeating-radial-gradient(circle at 50% 50%, hsl(${hue} 35% 30% / 0.4) 0 1px, transparent 1px 10px)`;
  } else if (variant === "block") {
    pattern = `linear-gradient(135deg, hsl(${hue} 40% 35%) 0 50%, hsl(${hue} 25% 70%) 50% 100%)`;
  }

  const size =
    variant === "dots" ? "12px 12px" :
    variant === "lines" ? "auto" :
    variant === "grid" ? "16px 16px, 16px 16px" :
    "auto";

  return (
    <div className={`relative overflow-hidden ${className}`} style={{ background }}>
      {pattern ? <div className="absolute inset-0" style={{ backgroundImage: pattern, backgroundSize: size }} /> : null}
      {label ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-smycles-micro tracking-[0.3em] text-ink-muted">{label}</span>
        </div>
      ) : null}
    </div>
  );
}
